/**
 * BETA — team (user) management.
 */
import { httpError } from "../router.js";
import { paginate, matchSearch, newId, nowIso } from "./_utils.js";

export function register(route) {
  route("GET", "/users", (ctx) => {
    const { params, store } = ctx;
    let rows = [...store.data.users];
    if (params.role) rows = rows.filter((u) => u.role === params.role);
    if (params.is_active !== undefined && params.is_active !== "") {
      const flag = params.is_active === "true" || params.is_active === true;
      rows = rows.filter((u) => !!u.is_active === flag);
    }
    if (params.search) {
      rows = rows.filter((u) => matchSearch(u, params.search, ["nom", "prenom", "email"]));
    }
    return paginate(rows, params);
  });

  route("GET", "/users/role-counts", (ctx) => {
    const counts = ctx.store.data.users.reduce(
      (acc, u) => ({ ...acc, [u.role]: (acc[u.role] || 0) + 1 }),
      {},
    );
    return {
      PROPRIETAIRE: counts.PROPRIETAIRE || 0,
      MANAGER: counts.MANAGER || 0,
      CAISSIER: counts.CAISSIER || 0,
    };
  });

  // X XWP-69 — paid user seats (demo: a trial officine, nothing to pay). Declared before /users/:id.
  route("GET", "/users/sieges/devis", (ctx) =>
    ["MANAGER", "CAISSIER"].includes(ctx.params.role)
      ? { consomme_siege: true, origine: "ESSAI", a_payer: false, collaborateur: false, tarif_annuel_da: null, jours: null, montant_da: "0.00", periode_fin: null }
      : { consomme_siege: false },
  );
  route("GET", "/users/sieges", () => ({ data: [], resume: { sieges_actifs: 0, en_attente: 0, tarif_annuel_da: null, fin_periode_licence: null } }));
  route("GET", "/users/moi/siege", () => ({ role: "PROPRIETAIRE", consomme_siege: false, etat: "SANS_SIEGE", siege: null }));
  route("POST", "/users/sieges/verifier", () => httpError(404, "Paiement introuvable", "NOT_FOUND"));

  route("GET", "/users/:id", (ctx) => {
    const u = ctx.store.data.users.find((x) => x.id === ctx.params.id);
    if (!u) httpError(404, "Utilisateur introuvable", "NOT_FOUND");
    return u;
  });

  route("POST", "/users", (ctx) => {
    const body = ctx.body || {};
    const created = {
      id: newId("user-new"),
      is_active: true,
      created_at: nowIso(),
      ...body,
    };
    ctx.store.data.users.push(created);
    ctx.commit();
    return created;
  });

  route("PATCH", "/users/:id", (ctx) => {
    const u = ctx.store.data.users.find((x) => x.id === ctx.params.id);
    if (!u) httpError(404, "Utilisateur introuvable", "NOT_FOUND");
    Object.assign(u, ctx.body || {});
    ctx.commit();
    return u;
  });

  route("PATCH", "/users/:id/toggle", (ctx) => {
    const u = ctx.store.data.users.find((x) => x.id === ctx.params.id);
    if (!u) httpError(404, "Utilisateur introuvable", "NOT_FOUND");
    if (ctx.body && "actif" in ctx.body) {
      u.is_active = !!ctx.body.actif;
    } else {
      u.is_active = !u.is_active;
    }
    ctx.commit();
    return u;
  });

  route("POST", "/users/:id/reset-password", () => ({ success: true }));
  route("POST", "/users/change-password", () => ({ success: true }));

  route("DELETE", "/users/:id", (ctx) => {
    const u = ctx.store.data.users.find((x) => x.id === ctx.params.id);
    if (!u) httpError(404, "Utilisateur introuvable", "NOT_FOUND");
    u.is_active = false;
    u.deleted_at = nowIso();
    ctx.commit();
    return { success: true };
  });
}
